const CustomerStatusRemarks = {
    CustomerRequest: "customer-request",
    Fraud: "fraud",
    Others: "others",
  };
  
  export default CustomerStatusRemarks;
  